import { useDispatch } from "react-redux";
import ResponsePhrasesTable from "./ResponsePhrasesTable";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getResponsePhrasesByPlantelThunk } from "../../store/reducers/plantels/plantels.thunks";
import Loader from "../UI/Loader";

const ResponsePhrasesTab = ({ plantelId }) => {
  // console.log(plantelId);
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.responsePhrases);

  useEffect(() => {
    if (plantelId) {
      dispatch(getResponsePhrasesByPlantelThunk(plantelId));
    }
  }, [plantelId, dispatch]);

  if (loading) return <Loader center text="Cargando frases..." />;

  return <ResponsePhrasesTable frases={list} />;
};

export default ResponsePhrasesTab;
